import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var TrendingOutlineSVG = function TrendingOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29,9H20a1,1,0,0,0,0,2h6.41l-9.5,9.59-6.7-7.11a1,1,0,0,0-.7-.32,1.1,1.1,0,0,0-.72.28l-6.48,6.1a1,1,0,0,0,0,1.39A1,1,0,0,0,3.7,21l5.73-5.41,6.73,7.13a1,1,0,0,0,.72.32h0a1,1,0,0,0,.72-.3L28,12.21V19a1,1,0,0,0,2,0V10A1,1,0,0,0,29,9Z"
  }));
};
TrendingOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TrendingOutlineSVG);